interface HeroProps {
  onRunHappyPath: () => void;
}

export function Hero({ onRunHappyPath }: HeroProps) {
  return (
    <header className="hero">
      <div className="top-bar">
        <span className="brand">Data Anonymizer</span>
        <span className="privacy-pill">
          <span aria-hidden="true">●</span> 100% en tu navegador — nada sale de tu dispositivo
        </span>
      </div>
      <h1>Haz visible lo que normalmente falla en silencio.</h1>
      <p className="lede">
        Carga un archivo local, aplica reglas de máscara y revisa una vista previa antes de descargar. El modo
        local no envía tus datos a ningún servidor.
      </p>
      <div className="action-row">
        <button type="button" className="button button-primary" onClick={onRunHappyPath}>
          Ejecutar escenario
        </button>
        <a className="button button-secondary" href="#how-it-works">
          Ver cómo funciona
        </a>
      </div>
      <p className="field-hint" style={{ marginTop: "12px" }}>
        <strong>Aviso importante:</strong> esta herramienta aplica transformaciones configurables. No certifica
        anonimización real ni protege por sí sola frente a reidentificación por combinación de campos.
      </p>
    </header>
  );
}
